export const simpleUserSerializerMap = {
  id: "id",
  firstName: "first_name",
  lastName: "last_name",
};
